import * as React from 'react';
import { StyleSheet, TextInput } from 'react-native';
import { Button } from 'react-native-elements';
import Container from '../components/Container';
import Separator from '../components/Separator';

import { Text } from '../components/Themed';

export default function Home({ navigation }) {
  const [Name, setName] = React.useState("");
  
  function onSumbit() {
      if (Name) {
          let nameShort = Name;
          if (Name.length > 4) {
              nameShort = Name.substring(0, 4);
          }
          navigation.navigate('Picture', { name: nameShort });
      }
  }

  return (
    <Container>
        <Text style={styles.title}>Bienvenue / Welcome</Text>
        <TextInput 
          style={styles.inputField}
          editable
          placeholder="Entrez votre nom / Enter your name"
          onChangeText={text => setName(text)}
          onSubmitEditing={() => onSumbit()}
          clearTextOnFocus={true}
          returnKeyType="next"
          autoCompleteType="name"
          enablesReturnKeyAutomatically={true}
        />
      <Separator />
      <Button
        title="Suivant / Next"
        onPress={() => onSumbit()}
      />
    </Container>
  );
}

const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 50
  },
  inputField: {
      height: 45,
      width: "80%",
      maxWidth: 300,
      fontSize: 16,
      borderRadius: 5,
      paddingLeft: 15,
      border: "1px solid #ccc",
      borderBottomWidth: 2,
      transition: "all 0.3s ease",
      color: "black",
  }
});
